/**
 * @param {number} speed
 * @returns {number}
 */
function getSpeedPxPerSec(speed) {
  return 28 + speed * 6;
}

/**
 * @param {HTMLElement} root
 */
function buildTrack(root) {
  var trackNode = root.querySelector('.custom-topbar__track');
  var viewportNode = root.querySelector('.custom-topbar__viewport');
  if (!(trackNode instanceof HTMLElement) || !(viewportNode instanceof HTMLElement)) return;

  var track = trackNode;
  var viewport = viewportNode;

  var sourceGroup = track.querySelector('.custom-topbar__group');
  if (!sourceGroup) return;

  var groupHTML = sourceGroup.innerHTML;
  track.innerHTML = '';

  var sequence = document.createElement('div');
  sequence.className = 'custom-topbar__sequence';
  sequence.setAttribute('aria-hidden', 'false');

  var firstGroup = document.createElement('div');
  firstGroup.className = 'custom-topbar__group';
  firstGroup.innerHTML = groupHTML;
  sequence.appendChild(firstGroup);
  track.appendChild(sequence);

  var viewportWidth = viewport.offsetWidth || window.innerWidth;
  var maxExtraGroups = 24;
  var extraGroupsAdded = 0;

  while (sequence.scrollWidth < viewportWidth && extraGroupsAdded < maxExtraGroups) {
    var previousWidth = sequence.scrollWidth;
    var extraGroup = document.createElement('div');
    extraGroup.className = 'custom-topbar__group';
    extraGroup.innerHTML = groupHTML;
    sequence.appendChild(extraGroup);
    extraGroupsAdded += 1;

    if (sequence.scrollWidth <= previousWidth) {
      break;
    }
  }

  var shift = sequence.getBoundingClientRect().width;
  if (!shift) return;

  var sequenceClone = sequence.cloneNode(true);
  if (!(sequenceClone instanceof HTMLElement)) return;
  sequenceClone.setAttribute('aria-hidden', 'true');
  track.appendChild(sequenceClone);

  track.style.setProperty('--custom-topbar-shift', shift + 'px');

  var speed = parseInt(root.getAttribute('data-speed') || '15', 10);
  var duration = shift / getSpeedPxPerSec(speed);
  track.style.setProperty('--custom-topbar-duration', Math.max(duration, 10) + 's');
}

/**
 * @param {HTMLElement} root
 */
function initCustomTopbar(root) {
  if (root.dataset.static === 'true') return;

  buildTrack(root);

  if (root.dataset.marqueeBound === 'true') return;
  root.dataset.marqueeBound = 'true';

  /** @type {ReturnType<typeof setTimeout> | undefined} */
  var resizeTimer;
  window.addEventListener('resize', function () {
    if (resizeTimer) clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      document.querySelectorAll('.custom-topbar:not([data-static="true"])').forEach(function (node) {
        if (node instanceof HTMLElement) buildTrack(node);
      });
    }, 150);
  });
}

function initAll() {
  document.querySelectorAll('.custom-topbar').forEach(function (node) {
    if (node instanceof HTMLElement) initCustomTopbar(node);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAll);
} else {
  initAll();
}

document.addEventListener('shopify:section:load', function (event) {
  var target = event.target;
  if (!(target instanceof HTMLElement)) return;

  var topbar = target.querySelector('.custom-topbar');
  if (topbar instanceof HTMLElement) initCustomTopbar(topbar);
});
